<style lang="less">
.page_con.score {
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.score .art_content {
    width: 100%;
    overflow: hidden;
    position: relative;
    flex: 1;
    // padding:.6rem 0 0;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: center;
    .pd {
        width: 100%;
        flex: 1;
        margin-top: 0.6rem;
        padding: 0 0.2rem;
    }
    .art_bottom {
        width: 100%;
        height: auto;
        position: relative;
        img.art_bottom_bg {
            width: 100%;
            height: auto;
            display: block;
        }
        img.art_bottom_flowers {
            width: 1.2rem;
            height: auto;
            display: block;
            position: absolute;
            left: 0.3rem;
            bottom: 0;
            z-index: 11;
        }
        img.art_bottom_sunflowers {
            width: 1.8rem;
            height: auto;
            display: block;
            position: absolute;
            right: 0rem;
            bottom: 0.1rem;
            z-index: 11;
        }
    }
}
.score .art_title {
    width: 100%;
    height: 1.3rem;
    font-size: 0.46rem;
    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
    color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../assets/images/title-pc.png") no-repeat;
    background-position: center;
    background-size: auto 100%;
    span {
        padding-bottom: 0.2rem;
    }
}
.score .art_text_con {
    width: 100%;
    height: auto;
    background: #78d3ff;
    border: 2px solid #1d2088;
    box-shadow: 0px 0.08rem 0.02rem 0px rgba(0, 0, 0, 0.3);
    border-radius: 0.1rem;
    padding: 0.9rem 0.2rem 0.2rem;
    > img {
        width: 100%;
        height: auto;
        display: block;
    }
    .art_inner {
        width: 100%;
        height: 60vh;
        background: #fffde4;
        // border-radius: .15rem;
        padding: 0.2rem;
        display: flex;
        flex-direction: column;
        > div {
            width: 100%;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            > img {
                width: 100%;
                height: auto;
                display: block;
                margin-bottom: 0.4rem;
            }
        }
    }
    .art_btns {
        width: 100%;
        padding: 0 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .btns_left {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .art_btn {
            width: 1.6rem;
            height: 0.8rem;
            margin-right: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.32rem;
            color: #fff;
            background: url("../assets/images/button2language-phone.png")
                no-repeat;
            background-size: 100% 100%;
            > span {
                margin-bottom: 0.1rem;
            }
        }
        .art_btn.active {
            background-image: url("../assets/images/button1language-phone.png");
        }
        .art_refresh {
            width: 1rem;
            height: 0.8rem;
            img {
                width: 100%;
                height: auto;
                display: block;
            }
        }
    }
}
.score .art_video_con {
    width: 100%;
    padding: 0 0.2rem;
    video {
        width: 100%;
        height: auto;
    }
}
.select_con {
    width: 5.95rem;
    margin: 0 auto 0.2rem;
    padding: 0 0.2rem;
}
.calendar {
    // width:100%;
    height: auto;
    > .calendar_row {
        width: 5.95rem;
        height: auto;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        > .calendar_day {
            width: 0.85rem;
            // width:14%;
            height: 1rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            border-right: 0.02rem solid #92be37;
        }
        > .calendar_day:nth-child(7) {
            border-right: none;
        }
    }
    > .calendar_row:nth-child(even) > .calendar_day {
        background: rgba(146, 190, 55, 0.2);
    }
    > .calendar_row:nth-child(even) > .calendar_day:nth-child(7) {
        border-top-right-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
    }
    > .calendar_row:nth-child(even) > .calendar_day:first-child {
        border-top-left-radius: 0.1rem;
        border-bottom-left-radius: 0.1rem;
    }
}
.day_num {
    width: 100%;
    padding: 0.15rem 0.1rem;
    font-size: 0.28rem;
    line-height: 1;
    font-weight: bold;
    text-align: right;
}
.flowers {
    width: 100%;
    padding: 0 0.05rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    img {
        width: 0.2rem;
        height: auto;
        display: block;
    }
}
.calendar_title {
    width: 5.95rem;
    height: 0.9rem;
    margin: 0 auto 0.2rem;
    background: #92be37;
    border-radius: 0.1rem;
    overflow: hidden;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    > div {
        width: 0.85rem;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
<template>
    <div class="page_con score">
        <div class="all_top">
            <div class="btnBack" @click="$router.go(-1)"></div>
            <div class="btnHome" @click="$router.push('/index')"></div>
        </div>
        <div class="art_content">
            <div class="pd">
                <div class="art_title">
                    <span>獲得的花朵</span>
                </div>
                <div class="art_text_con">
                    <!-- 蓝底 padding -->
                    <img src="../assets/images/up-article-phone.png" alt="" />
                    <div class="art_inner">
                        <!-- 黄底 padding -->
                        <div>
                            <div class="select_con">
                                <selectdown
                                    v-if="list.length"
                                    :list="list"
                                    :width="'3rem'"
                                    :height="'.9rem'"
                                    :type="'yellow'"
                                    @change="choice"
                                ></selectdown>
                            </div>
                            <div class="calendar_title">
                                <div>日</div>
                                <div>一</div>
                                <div>二</div>
                                <div>三</div>
                                <div>四</div>
                                <div>五</div>
                                <div>六</div>
                            </div>
                            <div class="calendar">
                                <div
                                    class="calendar_row"
                                    v-for="(week, index) in done_calendar"
                                    :key="index"
                                >
                                    <div
                                        class="calendar_day"
                                        v-for="(day, idx) in week"
                                        :key="idx"
                                    >
                                        <div class="day_num">
                                            {{ day ? day.day : "" }}
                                        </div>
                                        <div
                                            :dd="day.flower"
                                            v-if="day"
                                            class="flowers"
                                        >
                                            <img
                                                v-for="(
                                                    item, key
                                                ) in day.flower"
                                                :key="key"
                                                src="../assets/images/flower.png"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="../assets/images/down-article-phone.png" alt="" />
                </div>
            </div>
            <div class="art_bottom">
                <img
                    class="art_bottom_bg"
                    src="../assets/images/bg3-phone.png"
                    alt=""
                />
                <img
                    class="art_bottom_flowers"
                    src="../assets/images/flowers.gif"
                    alt=""
                />
                <img
                    class="art_bottom_sunflowers"
                    src="../assets/images/sunflower.gif"
                    alt=""
                />
            </div>
        </div>
    </div>
</template>
<script>
import selectdown from "./selectdown";
export default {
    components: {
        selectdown,
    },
    data() {
        return {
            list: [
                {
                    name: "",
                    value: "",
                },
            ],
            calendar: [],
            data: [],

            done_calendar: [],

            calendarDone: 0,
            dataDone: 0,
        };
    },
    mounted() {
        this.initDate();
    },
    methods: {
        choice(val) {
            console.log(val);
            this.calendar = this.initCalendar(val.value);
            this.getData(val.value.substring(0, 7));
        },
        initDate() {
            // let now = new Date().getTime();
            // let month_time = 86400000*30;
            // let arr = [];
            // for(let i=0;i<6;i++){
            //     let date = new Date(now - month_time*i);
            //     let month = date.getMonth()+1;
            //     let year = date.getFullYear();
            //     arr.push({
            //         name:year +'年'+month+'月',
            //         value:year + '-' + (month>9?month:'0'+month) + '-01'
            //     })
            // }
            // console.log(arr);
            // this.list = arr;

            let arr = [];
            let curM = new Date().getMonth() + 1;
            let curY = new Date().getFullYear();
            for (let i = 0; i < 6; i++) {
                let m = curM - i;
                let y = curY;
                if (m <= 0) {
                    y = y - 1;
                    m = 12 + m;
                }
                if (m != 8) {
                    arr.push({
                        name: y + "年" + m + "月",
                        value: y + "-" + this.addLength(m) + "-01",
                    });
                } else {
                    continue;
                }
            }
            this.list = arr;
            // let date = arr[0].value;
            // this.getData(date.substring(0, 7));
            let date = arr[0].value;
            this.calendar = this.initCalendar(date);
            this.getData(date.substring(0, 8));
        },
        getData(date) {
            let vm = this;
            // vm.$http.get("/Game/loadCalendar/setMonth/"+ date +"/sn/"+ Math.random())
            vm.$http
                .get(
                    this.baseUrl + "/Game/results.html?rest_key=1&date=" + date
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 1) {
                        vm.data = res.data.data.CalendarData;
                        vm.calendarDone = 1;
                        vm.initData();
                    }
                });
        },
        initData() {
            if (this.dataDone + this.calendarDone == 2) {
                let real = this.data;
                let data = this.calendar;
                data.forEach((week, i) => {
                    for (let j = 0; j < week.length; j++) {
                        let v = week[j];
                        for (let k = 0; k < real.length; k++) {
                            if (v.date == real[k].push_date) {
                                v.flower = Number(real[k].push_number);
                                break;
                            } else {
                                if (v.day) {
                                    v.flower = 0;
                                }
                            }
                        }
                    }
                });
                console.log(1111111111111111111111, data);
                this.$set(this, "done_calendar", data);
            }
        },
        initCalendar(date) {
            var curDate = new Date(date); //获取当前时间
            var curYear = curDate.getFullYear(); //当前年份
            var curMonth = curDate.getMonth() + 1; //当前月份
            // var curDay = curDate.getDay();//当前星期几
            var curnewDay = curDate.getDate(); //当前日
            // var weekfist = new Date(curYear, curMonth - 1, curnewDay - curDay).getDate()//获取当前周的第一天是几号
            var tmonth = new Date(curYear, curMonth, 0).getDate(); //当前月份有多少天
            var endDay = new Date(curYear, curMonth, 0).getDay(); //当前月最后一天是星期几
            var firstDay = new Date(curYear, curMonth - 1, 1).getDay(); //当前月第一天星期几  //周日在前面，所以加1
            // firstDay = 5
            let arr = [];
            let all = tmonth + firstDay;
            for (let i = 0; i < all; i++) {
                if (i < firstDay) {
                    arr.push({ day: "", date: "" });
                } else {
                    var day = i - firstDay + 1;
                    day = day > 9 ? day : "0" + day;
                    arr.push({
                        day: i - firstDay + 1,
                        date: date.substring(0, 8) + day,
                    });
                }
            }
            console.log("当前月第一天星期", firstDay, "总共", tmonth, "天");
            console.log(arr);
            let row = Math.ceil(arr.length / 7);
            let Calendar = [];
            for (let k = 0; k < row; k++) {
                var t = arr.slice(k * 7, (k + 1) * 7);
                if (t.length != 7) {
                    // t.length = 7;
                    for (let q = 0; q < 7; q++) {
                        if (t[q] === undefined) {
                            t[q] = { day: "", date: "" };
                        }
                    }
                }
                Calendar.push(Array.from(t));
            }
            console.log(Calendar);
            this.dataDone = 1;
            this.initData();
            return Calendar;
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/score.vue